import type { VoidFunctionComponent } from 'react';

import { useQuery } from '../../../contexts/RouterContext';
import Tabs from '../../generic/Tabs';
import {
  isLegalAgentQueryFiltered,
  parseLegalAgentQuery,
  serializeLegalAgentQuery,
} from '../legalAgentQuery';
import type { LegalAgentActor, LegalAgentQuery } from '../legalAgentQuery';

import { ActivityFeed } from './ActivityFeed';

const ACTOR_TABS: Array<{ label: string; actor: LegalAgentActor | null }> = [
  { label: 'All', actor: null },
  { label: 'Agent', actor: 'agent' },
  { label: 'You', actor: 'user' },
];

export const LegalAgentActivityPage: VoidFunctionComponent = () => {
  const [query, setQuery] = useQuery<LegalAgentQuery, Record<string, unknown>>(parseLegalAgentQuery);

  return (
    <section data-test-id="legal-agent-activity">
      <Tabs marginBottom="medium">
        {ACTOR_TABS.map(({ label, actor }) => (
          <Tabs.Tab
            key={label}
            label={label}
            isActive={query.actor === actor}
            onSelect={() => setQuery(serializeLegalAgentQuery({ ...query, actor }))}
          />
        ))}
      </Tabs>
      {/* The activity API is not wired up yet, so the feed always shows its loading state. */}
      <ActivityFeed isLoading isError={false} entries={null} isFiltered={isLegalAgentQueryFiltered(query)} />
    </section>
  );
};
